import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function HistoricMoments() {
  const {
    t
  } = useLanguage();
  const moments = [{
    title: t('history.wc2002'),
    year: '2002',
    videoId: 'O8dUhMGtUtw',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.pele'),
    year: '1958-1970',
    videoId: 'vSpofyhs0P8',
    colSpan: 'md:col-span-1',
    customImage: 'https://cdn.magicpatterns.com/uploads/wH6VrWqnaAZSCLGS51STUb/image.png'
  }, {
    title: 'Neymar — All Goals & Assists',
    year: '2026',
    videoId: '6FlKMyDwGx4',
    colSpan: 'md:col-span-1'
  }, {
    title: 'Ronaldo 2002 — Redemption',
    year: '2002',
    videoId: 'jEwkMblPhhc',
    colSpan: 'md:col-span-2'
  }, {
    title: 'Brazil 1970 — The Perfect Team',
    year: '1970',
    videoId: 'kBJVZ5k-F3M',
    colSpan: 'md:col-span-1'
  }, {
    title: 'Copa América 2019 — Glory at Home',
    year: '2019',
    videoId: 'zZMV3uvPdFw',
    colSpan: 'md:col-span-1'
  }, {
    title: '1958 World Cup — The Birth of a Dynasty',
    year: '1958',
    videoId: 'JE2xPzeSiBc',
    colSpan: 'md:col-span-1'
  }, {
    title: 'Best Brazil — Best FIFA World Cup Goals',
    year: '1958-2022',
    videoId: 'iU9rls0yu0Q',
    colSpan: 'md:col-span-2'
  }, {
    title: 'Italy vs Brazil — World Cup Final 1994',
    year: '1994',
    videoId: 'pLPM_JSbGvI',
    colSpan: 'md:col-span-1'
  }];
  return <section className="py-12 md:py-24 bg-brazil-black" data-id="element-174">
      <div className="container mx-auto px-6 md:px-12" data-id="element-175">
        <div className="mb-8 md:mb-12" data-id="element-176">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-brazil-green font-oswald uppercase tracking-widest text-sm font-bold mb-3" data-id="element-177">
            {t('history.label')}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-oswald font-bold uppercase" data-id="element-178">
            {t('history.title1')}{' '}
            <span className="text-brazil-yellow" data-id="element-179">{t('history.title2')}</span>
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-180">
          {moments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative rounded-2xl overflow-hidden aspect-video md:aspect-auto bg-[#111] ${moment.colSpan} md:h-[400px]`} data-id="element-181">
              <a href={`https://www.youtube.com/watch?v=${moment.videoId}`} target="_blank" rel="noopener noreferrer" className="absolute inset-0 w-full h-full group cursor-pointer block" data-id="element-182">
                <img src={moment.customImage || `https://img.youtube.com/vi/${moment.videoId}/maxresdefault.jpg`} alt={moment.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-183" />
                <div className="absolute inset-0 bg-gradient-to-t from-brazil-black via-brazil-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-184"></div>

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center transition-transform duration-300 transform group-hover:scale-110" data-id="element-185">
                  <div className="w-16 h-16 bg-brazil-blue/90 rounded-full flex items-center justify-center backdrop-blur-sm shadow-[0_0_30px_rgba(0,39,118,0.5)]" data-id="element-186">
                    <Play className="text-white ml-1" size={24} fill="currentColor" data-id="element-187" />
                  </div>
                </div>

                {/* YouTube badge */}
                <div className="absolute top-4 right-4 bg-[#FF0000] text-white text-[10px] font-oswald uppercase tracking-widest px-2 py-1 rounded flex items-center gap-1 z-10" data-id="element-188">
                  <Play size={10} fill="currentColor" data-id="element-189" /> YouTube
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-6 md:p-8" data-id="element-190">
                  <span className="inline-block bg-brazil-yellow text-brazil-black text-xs font-oswald uppercase tracking-widest px-2 py-1 rounded mb-3 font-bold" data-id="element-191">
                    {moment.year}
                  </span>
                  <h4 className="font-oswald text-xl md:text-3xl font-bold uppercase text-white drop-shadow-lg" data-id="element-192">
                    {moment.title}
                  </h4>
                </div>
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}